<template>
  <div class="col-md-12 p-0 client-store-page">
    <div class="client-store-hero">
      <div>
        <small>CLIENT DIRECTORY</small>
        <h3>Create New Client</h3>
        <p>Add client identity, contact details, and an accurate service location.</p>
      </div>
      <div class="client-store-hero-icon" aria-hidden="true">
        <i class="ti ti-user"></i>
      </div>
    </div>

    <form class="client-form-card" @submit="submit">
      <section class="client-form-section">
        <div class="client-section-heading">
          <span class="client-section-icon"><i class="ti ti-briefcase"></i></span>
          <div>
            <h5>Client Identity</h5>
            <p>Choose the responsible branch and enter the client name.</p>
          </div>
        </div>
        <div class="client-form-grid">
          <div class="client-field">
            <label>Branch Station <small class="text-danger">*</small></label>
            <SelectBranch
              v-if="isRoot"
              v-on:processBranch="processBranch"
              :title="'disable'"
            />
            <input
              v-else
              type="text"
              class="form-control client-readonly"
              v-model="branch_name"
              readonly
            />
            <small class="text-danger" v-if="msg_error.id_branch">{{
              msg_error.id_branch[0]
            }}</small>
          </div>
          <div class="client-field">
            <label>Client Name <small class="text-danger">*</small></label>
            <input
              type="text"
              class="form-control"
              placeholder="Enter client or company name"
              v-model="model.name"
            />
            <small class="text-danger" v-if="msg_error.name">{{
              msg_error.name[0]
            }}</small>
          </div>
        </div>
      </section>

      <section class="client-form-section">
        <div class="client-section-heading">
          <span class="client-section-icon"><i class="ti ti-email"></i></span>
          <div>
            <h5>Contact Information</h5>
            <p>Contact information used for operational communication.</p>
          </div>
        </div>
        <div class="client-form-grid">
          <div class="client-field">
            <label>Email Address <small class="text-danger">*</small></label>
            <input
              type="email"
              class="form-control"
              placeholder="client@example.com"
              v-model="model.email"
            />
            <small class="text-danger" v-if="msg_error.email">{{
              msg_error.email[0]
            }}</small>
          </div>
          <div class="client-field">
            <label>Phone Number <small class="text-danger">*</small></label>
            <input
              type="text"
              class="form-control"
              placeholder="Example: 08123456789"
              v-model="model.phone_number"
            />
            <small class="text-danger" v-if="msg_error.phone_number">{{
              msg_error.phone_number[0]
            }}</small>
          </div>
        </div>
      </section>

      <section class="client-form-section client-location-section">
        <div class="client-section-heading">
          <span class="client-section-icon"><i class="ti ti-location-pin"></i></span>
          <div>
            <h5>Client Location</h5>
            <p>Select the service area, then find or pinpoint the exact address.</p>
          </div>
        </div>
        <div class="client-form-grid">
          <div class="client-field">
            <label>Province <small class="text-danger">*</small></label>
            <input
              type="text"
              class="form-control client-readonly"
              :placeholder="isRoot ? 'Automatically selected from branch' : ''"
              v-model="provinces_name"
              readonly
            />
            <small class="client-field-hint">Automatically follows Branch Station.</small>
            <small class="text-danger" v-if="msg_error.id_propinsi">{{
              msg_error.id_propinsi[0]
            }}</small>
          </div>
          <div class="client-field">
            <label>City / Regency <small class="text-danger">*</small></label>
            <select
              v-model="model.id_kota"
              class="form-control"
              :disabled="model_kota.length < 1"
              @change="resetAddressForSelectedCity()"
            >
              <option disabled value="">-- Choose City / Regency --</option>
              <option
                v-for="(items, idx) in model_kota"
                :value="items.id"
                :key="idx"
              >
                {{ items.name || items.nama_kota }}
              </option>
            </select>
            <small class="client-field-hint" v-if="model_kota.length < 1">
              Choose Branch Station first.
            </small>
            <small class="text-danger" v-if="msg_error.id_kota">{{
              msg_error.id_kota[0]
            }}</small>
          </div>
        </div>

        <div class="client-map-panel" :class="{ 'is-disabled': !model.id_kota }">
          <div class="client-map-toolbar">
            <div>
              <strong>Pinpoint Client Address</strong>
              <small>Search an address, drag the marker, or click a point on the map.</small>
            </div>
            <span class="client-location-status is-ready" v-if="model.lat && model.lng">
              <i class="ti ti-check"></i> Location selected
            </span>
            <span class="client-location-status" v-else>
              <i class="ti ti-location-pin"></i> Waiting for location
            </span>
          </div>
          <Gmap
            name="example"
            :default_model="markerCoordinates"
            :location_bias="clientLocationBias"
            @locationChanged="applyMapLocation"
            v-if="isAutoloadMaps"
          ></Gmap>
          <div class="client-coordinate" v-if="model.lat && model.lng">
            <span>Latitude <b>{{ model.lat }}</b></span>
            <span>Longitude <b>{{ model.lng }}</b></span>
          </div>
          <small class="text-danger" v-if="msg_error.office_address">{{
            msg_error.office_address[0]
          }}</small>
          <small class="text-danger" v-if="msg_error.lat">{{
            msg_error.lat[0]
          }}</small>
          <small class="text-danger" v-if="msg_error.lng">{{
            msg_error.lng[0]
          }}</small>
        </div>
      </section>

      <div class="client-form-actions">
        <a href="javascript:;" class="btn btn-light" @click="$router.go(-1)">
          Cancel
        </a>
        <button type="submit" class="btn btn-primary btn-full-screen">
          <i class="ti ti-save"></i> Save Client
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Gmap from "../../../services/Gmap";
import $ from "jquery";
import axios from "axios";
import SelectBranch from "../../Branch/@SelectBranch";

export default {
  components: {
    Gmap,
    SelectBranch,
  },
  data() {
    return {
      isRoot: false,
      isAutoloadMaps: true,
      meta_url: "client",
      provinces_name: "",
      model: { id_propinsi: "", id_kota: "" },
      model_kota: [],
      markerCoordinates: [],

      branch_name: "",
      coll_branch: "",
    };
  },
  computed: {
    ...mapState("crud", {
      msg_error: (state) => state.error,
    }),
    clientLocationBias() {
      const selectedCity = this.model_kota.find(
        (city) => String(city.id) === String(this.model.id_kota)
      );
      return {
        city: selectedCity
          ? selectedCity.name || selectedCity.nama_kota || ""
          : "",
        province: this.provinces_name || "",
        country: "Indonesia",
      };
    },
  },
  created() {
    // default branch
    if (localStorage.getItem("userPrivilegesName") == "root") {
      this.isRoot = true;
    } else {
      this.branch_name = localStorage.getItem("userBranchName");
      this.model.id_branch = localStorage.getItem("userBranchId");
      this.model.id_propinsi = localStorage.getItem("id_provinces");
      this.provinces_name = localStorage.getItem("provinces_name");
      this.fetchKota();
    }
  },

  methods: {
    async processBranch(data) {
      this.model.id_branch = data;
      this.resetClientLocation();
      if (!data || data === "all") {
        this.model.id_propinsi = "";
        this.provinces_name = "";
        this.model_kota = [];
        return;
      }

      try {
        const response = await axios.get("branch/find/" + data);
        const branch = response.data || {};
        this.model.id_propinsi = branch.id_provinces || "";
        await this.loadProvinceName(branch.id_provinces);
        await this.fetchKotaByBranch(branch);
      } catch (error) {
        this.model.id_propinsi = "";
        this.provinces_name = "";
        this.model_kota = [];
        console.log("error fetch branch detail", error);
      }
    },
    async fetchKota() {
      this.model_kota =
        JSON.parse(localStorage.getItem("data_regencies") || "[]") || [];
    },
    async loadProvinceName(idProvince) {
      if (!idProvince) {
        this.provinces_name = "";
        return;
      }
      const response = await axios.post("location/propinsi/data", {
        where: { key: "id", value: idProvince },
      });
      const province = response.data && response.data[0];
      this.provinces_name = province ? province.nama_provinsi : "";
    },
    async fetchKotaByBranch(branch) {
      if (
        branch.applying_regencies === "selected-area" &&
        branch.group_regencies
      ) {
        const selectedCities =
          typeof branch.group_regencies === "string"
            ? JSON.parse(branch.group_regencies)
            : branch.group_regencies;
        this.model_kota = Array.isArray(selectedCities) ? selectedCities : [];
        return;
      }

      const response = await axios.post("location/kota/data", {
        where: { key: "provinsi_id", value: branch.id_provinces },
        order: { key: "id", value: "asc" },
      });
      this.model_kota = response.data || [];
    },
    resetClientLocation() {
      this.model.id_kota = "";
      this.model.office_address = "";
      this.model.lat = "";
      this.model.lng = "";
      this.markerCoordinates = {};
      this.reloadMap();
    },
    resetAddressForSelectedCity() {
      this.model.office_address = "";
      this.model.lat = "";
      this.model.lng = "";
      this.markerCoordinates = {};
      this.reloadMap();
    },
    reloadMap() {
      this.isAutoloadMaps = false;
      setTimeout(() => {
        this.isAutoloadMaps = true;
      }, 200);
    },
    applyMapLocation(location) {
      this.model.office_address = location.address || "";
      this.model.lat = location.latitude;
      this.model.lng = location.longitude;
    },

    async submit(e) {
      e.preventDefault();
      this.$store.state.loading.msg = "Processing submit data...";
      this.$store.state.loading.status = true;

      // google lat and lng
      const addressInput = document.getElementById("input_address");
      const latitudeInput = document.getElementById("input_lat");
      const longitudeInput = document.getElementById("input_lon");
      this.model.office_address = addressInput
        ? addressInput.value
        : this.model.office_address;
      this.model.lat = latitudeInput ? latitudeInput.value : this.model.lat;
      this.model.lng = longitudeInput ? longitudeInput.value : this.model.lng;

      let data = {
        url: this.meta_url + "/store",
        callback_url: this.meta_url + "/data",
        form_data: this.model,
      };
      await this.$store.dispatch("crud/storeData", data);
    },
  },
};
</script>

<style lang="scss" scoped>
.client-store-page {
  color: #26374a;
}
.client-store-hero {
  align-items: center;
  background: linear-gradient(120deg, #326f9c 0%, #3193a7 58%, #55b9b8 100%);
  border-radius: 14px;
  box-shadow: 0 12px 28px rgba(20, 77, 126, 0.18);
  color: #fff;
  display: flex;
  justify-content: space-between;
  margin-bottom: 22px;
  min-height: 150px;
  overflow: hidden;
  padding: 28px 34px;
  position: relative;
}
.client-store-hero::after {
  background: rgba(255, 255, 255, 0.08);
  border-radius: 50%;
  content: "";
  height: 230px;
  position: absolute;
  right: -55px;
  top: -90px;
  width: 230px;
}
.client-store-hero small {
  color: #8ff3e8;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.8px;
}
.client-store-hero h3 {
  color: #fff;
  font-size: 24px;
  margin: 5px 0 4px;
}
.client-store-hero p {
  color: rgba(255, 255, 255, 0.88);
  margin: 0;
}
.client-store-hero-icon {
  align-items: center;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 14px;
  display: flex;
  font-size: 34px;
  height: 72px;
  justify-content: center;
  position: relative;
  width: 72px;
  z-index: 1;
}
.client-form-card {
  background: #fff;
  border: 1px solid #e5ebf1;
  border-radius: 14px;
  box-shadow: 0 10px 30px rgba(33, 55, 79, 0.08);
  overflow: hidden;
}
.client-form-section {
  border-bottom: 1px solid #e8edf2;
  padding: 28px 32px;
}
.client-section-heading {
  align-items: center;
  display: flex;
  gap: 12px;
  margin-bottom: 22px;
}
.client-section-heading h5 {
  color: #1f344b;
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 3px;
}
.client-section-heading p {
  color: #778595;
  font-size: 12px;
  margin: 0;
}
.client-section-icon {
  align-items: center;
  background: #eaf5ff;
  border-radius: 10px;
  color: #087cbb;
  display: flex;
  flex: 0 0 42px;
  font-size: 18px;
  height: 42px;
  justify-content: center;
}
.client-form-grid {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.client-field {
  min-width: 0;
}
.client-field label {
  color: #435469;
  display: block;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 7px;
}
.client-field .form-control,
.client-field::v-deep .form-control {
  border: 1px solid #d6e0e9;
  border-radius: 7px;
  min-height: 42px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.client-field .form-control:focus,
.client-field::v-deep .form-control:focus {
  border-color: #188ac2;
  box-shadow: 0 0 0 3px rgba(24, 138, 194, 0.12);
}
.client-readonly {
  background: #f1f4f7;
  color: #657487;
}
.client-field-hint {
  color: #8a97a5;
  display: block;
  font-size: 10px;
  margin-top: 5px;
}
.client-map-panel {
  background: #f8fafc;
  border: 1px solid #dfe7ef;
  border-radius: 10px;
  margin-top: 22px;
  padding: 18px;
}
.client-map-panel.is-disabled {
  background: #fbfcfd;
}
.client-map-toolbar {
  align-items: center;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  margin-bottom: 14px;
}
.client-map-toolbar strong,
.client-map-toolbar small {
  display: block;
}
.client-map-toolbar strong {
  color: #29405a;
  font-size: 13px;
}
.client-map-toolbar small {
  color: #7c8998;
  font-size: 10px;
  margin-top: 3px;
}
.client-location-status {
  align-items: center;
  background: #fff5dd;
  border: 1px solid #f1d28c;
  border-radius: 999px;
  color: #805e10;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 10px;
  font-weight: 600;
  gap: 5px;
  padding: 7px 10px;
}
.client-location-status.is-ready {
  background: #e9f8f2;
  border-color: #a9dfcb;
  color: #157151;
}
.client-coordinate {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
}
.client-coordinate span {
  background: #edf3f8;
  border-radius: 6px;
  color: #647285;
  font-size: 10px;
  padding: 6px 9px;
}
.client-coordinate b {
  color: #334a62;
  font-weight: 600;
  margin-left: 4px;
}
.client-form-actions {
  align-items: center;
  background: #fbfcfd;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding: 20px 32px;
}
.client-form-actions .btn {
  border-radius: 7px;
  min-width: 130px;
  padding: 10px 18px;
}

@media (max-width: 767px) {
  .client-store-hero {
    margin-bottom: 14px;
    min-height: 132px;
    padding: 22px 20px;
  }
  .client-store-hero h3 {
    font-size: 20px;
  }
  .client-store-hero p {
    font-size: 11px;
    max-width: 260px;
  }
  .client-store-hero-icon {
    display: none;
  }
  .client-form-section {
    padding: 22px 16px;
  }
  .client-form-grid {
    gap: 16px;
    grid-template-columns: 1fr;
  }
  .client-map-panel {
    padding: 12px;
  }
  .client-map-toolbar {
    align-items: flex-start;
    flex-direction: column;
    gap: 9px;
  }
  .client-form-actions {
    align-items: stretch;
    flex-direction: column-reverse;
    padding: 16px;
  }
  .client-form-actions .btn {
    margin: 0;
    text-align: center;
    width: 100%;
  }
}
</style>
